import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`} data-id="element-159">
      {children}
    </div>;
}